export default () => {

  const a = {}
  const init = () => {
    console.log('init flip turn');
    a.targets = document.querySelectorAll('.js-flip');
    if (a.targets.length == 0) {
      return;
    }

    buildFlipTurn();
  }

  const buildFlipTurn = () => {
    a.targets.forEach(flipRoot => {
      const card = flipRoot.querySelector('.js-flip-target');
      const btn = flipRoot.querySelector('.js-flip-btn');
      btn.addEventListener('click', () => {
        card.classList.toggle('is-turn');
      })
      card.addEventListener('click', () => {
        card.classList.toggle('is-turn');
      })
    });
  }

  init();

  return {}
}
